module.exports = __webpack_public_path__ + "static/media/BTT.8d3b6b63.svg";